import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'
import { useTheme } from 'styled-components'

import { ActionButtonProps } from '../ActionButton'
import { ScoreStarProps } from '../ScoreStar'
import { AvatarProps } from '../Avatar'
import { LinkProps } from '../Link'

import * as SC from './styled'

export type MembersFeedbackProps = {
  className?: string
  title: string
  numberFeedback: string
  averageScore?: ScoreStarProps
  noFeedbackText?: string

  memberFeedbackItem?: Array<{
    avatar?: AvatarProps
    memberOpinion: string
    memberName: string
    memberDate: string
    memberScore: string

    actions?: {
      editOnClick?: () => void
      deleteOnClick?: () => void
    }
  }>

  button?: ActionButtonProps
  pendingFeedbackText?: string
  link?: LinkProps
  isLogInAndMember?: boolean
  imageFeedBacksTransparent: ImageProps
  isFirstLoading: boolean
  isMoreLoading: boolean
}

const MembersFeedback: FC<MembersFeedbackProps> = ({
  className,
  title,
  numberFeedback,
  averageScore,
  noFeedbackText,
  memberFeedbackItem,
  button,
  pendingFeedbackText,
  link,
  isLogInAndMember,
  imageFeedBacksTransparent,
  isFirstLoading,
  isMoreLoading,
}) => {
  const theme = useTheme()

  return (
    <SC.Feedback
      className={cx('Feedback', className)}
      $isLogInAndMember={isLogInAndMember}
    >
      {isLogInAndMember ? (
        <>
          <SC.Header>
            <SC.Title>{title}</SC.Title>
            <SC.NumberFeedback>{numberFeedback}</SC.NumberFeedback>
            <SC.ScoreWrapper>
              {averageScore && <SC.Score {...averageScore} />}
            </SC.ScoreWrapper>
          </SC.Header>
          <SC.MemberFeedbackBlockWrapper $isLogInAndMember={isLogInAndMember}>
            {memberFeedbackItem &&
              memberFeedbackItem.map((item, index) => (
                <SC.MemberFeedbackBlock key={index}>
                  <SC.MemberAvatar {...item.avatar} />
                  <SC.MemberNameDescriptionBlock>
                    <SC.FeedbackEntryHead>
                      <SC.MemberName>{item.memberName}</SC.MemberName>
                      <SC.MemberDate>{item.memberDate}</SC.MemberDate>
                    </SC.FeedbackEntryHead>
                    <SC.MemberDescription>
                      {item.memberOpinion}
                    </SC.MemberDescription>
                  </SC.MemberNameDescriptionBlock>
                  <SC.Sidebar>
                    <SC.MemberScore>{item.memberScore}/5</SC.MemberScore>
                    {item?.actions && (
                      <SC.Actions>
                        <SC.Action onClick={item.actions.editOnClick}>
                          <SC.StyledIcon icon="pencil" width={24} height={24} />
                        </SC.Action>
                        <SC.Action onClick={item.actions.deleteOnClick}>
                          <SC.StyledIcon icon="bin" width={24} height={24} />
                        </SC.Action>
                      </SC.Actions>
                    )}
                  </SC.Sidebar>
                </SC.MemberFeedbackBlock>
              ))}
            {noFeedbackText && (
              <SC.NoFeedbackText>{noFeedbackText}</SC.NoFeedbackText>
            )}
          </SC.MemberFeedbackBlockWrapper>

          <SC.LoaderFirst
            color={theme.colors.bluePrimary}
            loading={isFirstLoading}
            size={10}
          />
          <SC.ButtonBlock>
            {pendingFeedbackText ? (
              <SC.PendingFeedbackText>
                {pendingFeedbackText}
              </SC.PendingFeedbackText>
            ) : button ? (
              <SC.AddOpinion {...button} />
            ) : (
              <div></div>
            )}
            {link && !isMoreLoading && <SC.SeeMoreOpinion {...link} />}
            <SC.Loader
              color={theme.colors.bluePrimary}
              loading={isMoreLoading}
              size={10}
            />
          </SC.ButtonBlock>
        </>
      ) : (
        <SC.ImageFeedBacksTransparent {...imageFeedBacksTransparent} />
      )}
    </SC.Feedback>
  )
}

export default MembersFeedback
